import { render } from "./LIFFFormApp.vue?vue&type=template&id=b3dd0126&scoped=true"
import script from "./LIFFFormApp.vue?vue&type=script&lang=ts"
export * from "./LIFFFormApp.vue?vue&type=script&lang=ts"

import "./LIFFFormApp.vue?vue&type=style&index=0&id=b3dd0126&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b3dd0126"

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QSpinnerDots});
